/**
 * Returns the current environment based on the URL.
 * @param {string} url - The URL to check.
 */
export function getCurrentEnv(
  url: string
): 'dev' | 'test' | 'uat' | 'prod' | 'unknown' {
  if (
    url.includes('localhost') ||
    url.includes('internal') ||
    url.includes('dev-app.inpay.com')
  ) {
    return 'dev';
  } else if (url.includes('test-app.inpay.com')) {
    return 'test';
  } else if (url.includes('uat-app.inpay.com')) {
    return 'uat';
  } else if (url.includes('app.inpay.com')) {
    return 'prod';
  } else {
    return 'unknown'; // If the URL does not match any known environment
  }
}
